require("source-map-support").install(), function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define("WarningNotification", [], n) : "object" == typeof exports ? exports.WarningNotification = n() : e.WarningNotification = n();
}(this, function () {
  return function (e) {
    var n = {};

    function r(t) {
      if (n[t]) return n[t].exports;
      var o = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = n, r.d = function (e, n, t) {
      r.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: t
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, n) {
      if (1 & n && (e = r(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (r.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) {
        r.d(t, o, function (n) {
          return e[n];
        }.bind(null, o));
      }
      return t;
    }, r.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(n, "a", n), n;
    }, r.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, r.p = "/", r(r.s = 446);
  }({
    0: function _(e, n) {
      e.exports = require("react");
    },
    1: function _(e, n) {
      e.exports = require("prop-types");
    },
    10: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(1),
          a = r.n(i),
          u = r(2);

      function c() {
        var e = o()(["\n  align-content: ", ";\n  align-items: ", ";\n  align-self: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  order: ", ";\n  overflow: ", ";\n"]);
        return c = function c() {
          return e;
        }, e;
      }

      var s = r.n(u).a.div(c(), function (e) {
        return e.alignContent;
      }, function (e) {
        return e.alignItems;
      }, function (e) {
        return e.alignSelf;
      }, function (e) {
        return e.inline ? "inline-flex" : "flex";
      }, function (e) {
        return e.flexBasis;
      }, function (e) {
        return e.flexDirection;
      }, function (e) {
        return e.flexGrow;
      }, function (e) {
        return e.flexShrink;
      }, function (e) {
        return e.flexWrap ? "wrap" : "nowrap";
      }, function (e) {
        return e.justifyContent;
      }, function (e) {
        return e.order;
      }, function (e) {
        return e.overflow;
      });
      s.propTypes = {
        alignContent: a.a.string,
        alignItems: a.a.string,
        alignSelf: a.a.string,
        flexBasis: a.a.oneOfType([a.a.number, a.a.string]),
        flexDirection: a.a.string,
        flexGrow: a.a.number,
        flexShrink: a.a.number,
        flexWrap: a.a.bool,
        inline: a.a.bool,
        justifyContent: a.a.string,
        overflow: a.a.string,
        order: a.a.number
      }, s.defaultProps = {
        alignContent: "stretch",
        alignItems: "stretch",
        alignSelf: "auto",
        flexBasis: "auto",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
        flexWrap: !1,
        inline: !1,
        justifyContent: "flex-start",
        order: 0,
        overflow: "hidden"
      }, s.displayName = "FlexContainer", n.a = s;
    },
    101: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(0),
          a = r.n(i),
          u = r(22),
          c = r(12),
          s = r(118),
          f = r(2),
          l = r.n(f),
          d = r(8),
          g = r(46),
          p = r(5);

      function y() {
        var e = o()(["\n  padding-right: 10px;\n  display: flex;\n  height: 22px;\n  align-items: center;\n"]);
        return y = function y() {
          return e;
        }, e;
      }

      function h() {
        var e = o()(["\n  font-size: 18px;\n"]);
        return h = function h() {
          return e;
        }, e;
      }

      u.library.add(s.faBell);

      var b = l()(c.FontAwesomeIcon).attrs({
        icon: ["far", "bell"],
        color: Object(p.e)("warning")
      })(h()),
          m = l.a.div(y()),
          x = function x(e) {
        var n = e.successText,
            r = e.text;
        return a.a.createElement(g.a, {
          uistyle: "warning"
        }, a.a.createElement(m, null, a.a.createElement(b, null)), n && a.a.createElement(d.a, {
          uistyle: "secondary",
          text: "".concat(n, ": "),
          weight: "bold"
        }), a.a.createElement(d.a, {
          uistyle: "secondary",
          text: r
        }));
      };

      x.defaultProps = {
        successText: void 0
      }, x.displayName = "WarningNotification", n.a = x;
    },
    118: function _(e, n) {
      e.exports = require("@fortawesome/pro-regular-svg-icons/faBell");
    },
    12: function _(e, n) {
      e.exports = require("@fortawesome/react-fontawesome");
    },
    14: function _(e, n) {
      e.exports = require("lodash.memoize");
    },
    2: function _(e, n) {
      e.exports = require("styled-components");
    },
    211: function _(e, n, r) {
      "use strict";

      r.r(n);
      var t = r(101);
      n.default = t.a;
    },
    22: function _(e, n) {
      e.exports = require("@fortawesome/fontawesome-svg-core");
    },
    3: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    4: function _(e) {
      e.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    446: function _(e, n, r) {
      e.exports = r(211);
    },
    46: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(0),
          a = r.n(i),
          u = r(2),
          c = r.n(u),
          s = r(10),
          f = r(5);

      function l() {
        var e = o()(["\n  padding: 8px;\n  border: ", " solid 1px;\n  border-radius: 3px;\n  background-color: ", ";\n"]);
        return l = function l() {
          return e;
        }, e;
      }

      var d = c()(s.a)(l(), function (e) {
        var n = e.theme.colors,
            r = e.uistyle;
        return Object(f.e)(r, n);
      }, function (e) {
        var n = e.theme.colors,
            r = e.uistyle;
        return Object(f.c)(r, n);
      }),
          g = function g(e) {
        var n = e.children,
            r = e.uistyle,
            t = e.justifyContent;
        return a.a.createElement(d, {
          alignItems: "flex-start",
          uistyle: r,
          justifyContent: t
        }, n);
      };

      g.defaultProps = {
        justifyContent: "flex-start"
      }, n.a = g;
    },
    5: function _(e, n, r) {
      "use strict";

      r.d(n, "a", function () {
        return h;
      }), r.d(n, "e", function () {
        return i;
      }), r.d(n, "j", function () {
        return a;
      }), r.d(n, "f", function () {
        return u;
      }), r.d(n, "g", function () {
        return c;
      }), r.d(n, "i", function () {
        return l;
      }), r.d(n, "c", function () {
        return d;
      }), r.d(n, "k", function () {
        return d;
      }), r.d(n, "l", function () {
        return g;
      }), r.d(n, "b", function () {
        return p;
      }), r.d(n, "d", function () {
        return y;
      }), r.d(n, "h", function () {
        return f;
      });

      var t = r(4),
          o = r(9),
          i = function i(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand;

          case "secondary":
          case "normal":
          default:
            return n.grey;

          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          case "brand160":
            return n.brand160;

          case "white":
            return n.white;
        }
      },
          a = function a(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand60;

          case "secondary":
          case "normal":
          default:
            return n.grey40;

          case "info":
            return n.infolight;

          case "support":
            return n.supportlight;

          case "success":
            return n.successlight;

          case "warning":
            return n.warninglight;

          case "alert":
            return n.alertlight;

          case "grey20":
          case "white":
            return n.grey20;
        }
      },
          u = function u(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand120;

          case "secondary":
          case "normal":
          default:
            return n.grey140;

          case "info":
            return n.infohover;

          case "support":
            return n.supporthover;

          case "success":
            return n.successhover;

          case "warning":
            return n.warninghover;

          case "alert":
            return n.alerthover;

          case "white":
            return n.grey20;
        }
      },
          c = function c(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o;

        switch (e) {
          case "xxs":
            return n.Body4;

          case "xs":
            return n.Body3;

          case "sm":
            return n.Body2;

          case "md":
          default:
            return n.Body1;

          case "lg":
            return n.H5;

          case "xl":
            return n.H4;

          case "xxl":
            return n.H3;

          case "xxxl":
            return n.H2;

          case "xxxxl":
            return n.H1;
        }
      },
          s = Object.freeze({
        xs: 24,
        sm: 30,
        md: 40,
        lg: 50
      }),
          f = function f(e) {
        return s[e] || s.md;
      },
          l = function l(e, n) {
        var r = {
          padding: {
            vertical: 0,
            horizontal: 10
          },
          font: {},
          supportFont: {},
          height: 0
        };

        switch (e) {
          case "xs":
            r.padding.vertical = 6, r.font = n.Body3, r.supportFont = n.Body4;
            break;

          case "sm":
            r.padding.vertical = 8, r.font = n.Body1, r.supportFont = n.Body3;
            break;

          default:
          case "md":
            r.padding.vertical = 12, r.font = n.Body1, r.supportFont = n.Body3;
            break;

          case "lg":
            r.padding.vertical = 17, r.font = n.Body1, r.supportFont = n.Body3;
        }

        return r.height = f(e), r;
      },
          d = function d(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand10;

          case "info":
            return n.infobackground;

          case "support":
            return n.supportbackground;

          case "success":
            return n.successbackground;

          case "warning":
            return n.warningbackground;

          case "alert":
            return n.alertbackground;

          case "normal":
          default:
            return n.white;
        }
      },
          g = function g(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "warning":
            return n.brand160;

          case "info":
          case "support":
          case "success":
          case "alert":
          default:
            return n.white;
        }
      },
          p = function p(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          default:
            return n.brand;
        }
      },
          y = function y(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          default:
            return n.brand;
        }
      },
          h = new Map([[0, "rgb(110,73,244)"], [1, "#098256"], [2, "#7300B3"], [3, "#052066"], [4, "#6E49F4"], [5, "#0A40CC"], [6, "#FFB300"], [7, "#FF1E0E"], [8, "#038F00"], [9, "#CC34AF"], [10, "#11AEEF"], [11, "#475B68"], [12, "#DC1E7C"], [13, "#30C881"], [14, "#FF6A12"], [15, "#2D9898"]]);
    },
    8: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(2),
          a = r.n(i),
          u = r(1),
          c = r.n(u),
          s = r(14),
          f = r.n(s),
          l = r(5);

      function d() {
        var e = o()(["\n    color: ", ";\n  "]);
        return d = function d() {
          return e;
        }, e;
      }

      function g() {
        var e = o()(["\n    line-height: ", "px;\n    font-size: ", "px;\n    font-family: ", ";\n  "]);
        return g = function g() {
          return e;
        }, e;
      }

      var p = f()(function (e) {
        var n = e.theme.fonts,
            r = e.size,
            t = Object(l.g)(r, n);
        return Object(i.css)(g(), t.lineHeight, t.fontSize, t.fontFamily);
      }, function (e) {
        return e.size;
      }),
          y = f()(function (e) {
        var n = e.lighter,
            r = e.theme.colors,
            t = e.uistyle,
            o = n ? Object(l.j)(t, r) : Object(l.e)(t, r);
        return Object(i.css)(d(), o);
      }, function (e) {
        var n = e.lighter,
            r = e.uistyle;
        return "".concat(n, "-").concat(r);
      });

      function h() {
        var e = o()(["\n  transition: 0.15s ease-in-out color;\n  ", "\n  ", "\n  font-weight: ", ";\n\n  padding: 0;\n  margin: 0;\n"]);
        return h = function h() {
          return e;
        }, e;
      }

      var b = a.a.p.attrs({
        children: function children(e) {
          return e.children || e.text;
        }
      })(h(), y, p, function (e) {
        return e.weight;
      });
      b.propTypes = {
        uistyle: c.a.string,
        size: c.a.oneOf(["xxl", "xl", "lg", "md", "sm", "xs", "xxs"]),
        lighter: c.a.bool,
        weight: c.a.oneOf(["normal", "bold", 600])
      }, b.defaultProps = {
        uistyle: "normal",
        size: "md",
        lighter: !1,
        weight: "normal"
      }, b.displayName = "Text";
      n.a = b;
    },
    9: function _(e) {
      e.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    }
  });
});